<template>
  <div id="app">
    <Header />
    <main>
      <transition :name="transitionName" mode="out-in">
        <router-view :key="$route.fullPath"/>
      </transition>
    </main>
    <Footer />
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'

export default {
  name: 'App',
  components: {
    Header,
    Footer
  },
  mounted() {
    // if (window.wx) {
    //   window.wx.config({
    //     debug: true, // 开启调试模式
    //     appId: 'your-app-id', // 公众号的唯一标识
    //     timestamp: 1234567890, // 时间戳
    //     nonceStr: 'random-string', // 随机字符串
    //     signature: 'generated-signature', // 签名
    //     jsApiList: ['chooseImage', 'onMenuShareTimeline'] // 需要调用的接口列表
    //   });
    // }
  },
  data() {
    return {
      transitionName: 'fade'
    }
  },
  watch: {
    $route(to, from) {
      // 根据路由深度决定动画方向
      const toDepth = to.meta.depth || 0
      const fromDepth = from.meta.depth || 0
      this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
      window.scrollTo(0, 0)
    }
  },
  created() {
    window.scrollTo(0, 0)
  }
}
</script>

<style>
html,body {
  overflow-x: hidden;
}
</style>
<style lang="scss">
@use "@/assets/css/theme-1.scss";
/* 全局样式 */
body {
  font-family: 'Arial', sans-serif;
  margin: 0;
  padding: 0;
  background-color: #f9f9f9;
  color: #333;
  overflow-x: hidden;
}

#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

main {
  flex: 1;
  padding: 20px;
  min-height: calc(100vh - 80px);
}

/* 淡入淡出动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* 滑动动画 */
.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition: all 0.4s cubic-bezier(0.55, 0, 0.1, 1);
  position: absolute;
  width: calc(100% - 40px);
}

.slide-left-enter-from {
  opacity: 0;
  transform: translateX(50px);
}

.slide-left-leave-to {
  opacity: 0;
  transform: translateX(-50px);
}

.slide-right-enter-from {
  opacity: 0;
  transform: translateX(-50px);
}

.slide-right-leave-to {
  opacity: 0;
  transform: translateX(50px);
}

@media (max-width: 768px) {
  main {
    padding: unset;
  }
  .breadcrumb {
    padding: 8px 20px!important;
  }
  [class*="-page"] [class*="-section"] {
    padding: 0 20px !important;
  }
  .gallery-grid {
    padding: 20px 0!important;
  }
}
</style>
